import styles from "./dashboard.module.css";
import PropTypes from "prop-types";

const Card = ({ item }) => {
  return (
    <div
      className={`${styles.card} ${
        item?.isSelected ? styles.selectedCard : styles.nonSelectedCard
      }`}
    >
      <div className={styles.cardContainer}>
        <h1 className={styles.cardTitle}>{item?.title}</h1>
        <h4 className={styles.cardAmount}>{item?.amount || 0}</h4>
      </div>
    </div>
  );
};

Card.propTypes = {
  item: PropTypes.shape({
    isSelected: PropTypes.bool,
    title: PropTypes.string.isRequired,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    percentageChange: PropTypes.number,
    description: PropTypes.string,
  }).isRequired,
};

export default Card;
